import React, { useEffect, useState } from 'react'
import {
  Flex,
  PageWrapper,
  Separator,
  H2,
  ItemsGrid,
} from '../../../styling/GlobalStyles'
import { NavBar } from '../../../components/NavBar/NavBar'
import { InfoCard } from 'components/InfoCard/InfoCard'
import { MetricCard } from 'components/ui/MetricCard/MetricCard'
import { PageTitle } from 'pages/HrDashboard/hrLayout.styled'
import { KpiRow } from './Costs.styled'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { getOverview } from 'features/finances/financesSlice'
import { endOfWeek, startOfWeek } from 'date-fns'
import CalendarInput from 'components/CalendarInput/CalendarInput'

export const Costs = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { overview } = useSelector((state: RootState) => state.finances)
  const [startDate, setStartDate] = useState(startOfWeek(new Date(), { weekStartsOn: 1 }))
  const [endDate, setEndDate] = useState(endOfWeek(new Date(), { weekStartsOn: 1 }))

  useEffect(() => {
    dispatch(
      getOverview({
        startDate: startDate?.toISOString().substr(0, 10),
        endDate: endDate?.toISOString().substr(0, 10),
      }),
    )
  }, [startDate, endDate])

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between mb='16'>
          <PageTitle>Costs Overview</PageTitle>
          <Flex gap='1rem'>
            <CalendarInput
              maxDate={endDate}
              labelText='Start date'
              defaultValue={startDate}
              onChange={v => setStartDate(v)}
            />
            <CalendarInput
              minDate={startDate}
              labelText='End date'
              defaultValue={endDate}
              onChange={v => setEndDate(v)}

            />
          </Flex>
        </Flex>
        <KpiRow>
          <MetricCard label='Task Count' value={String(overview?.overview.tasksCount || 0)} />
          <MetricCard
            label='Estimated Cost'
            value={String(overview?.overview?.estimatedCost?.toFixed(2) || 0)}
          />
          <MetricCard
            label='Actual Cost'
            value={String(overview?.overview?.actualCost?.toFixed(2) || 0)}
          />
        </KpiRow>
        <Separator />
        <H2 mb='40px'>Sites</H2>
        <ItemsGrid columns={3}>
          {overview?.overviewByDepartments &&
            overview.overviewByDepartments.map((item, i) => {
              return <InfoCard title={item.siteName} data={item} key={i} />
            })}
        </ItemsGrid>
      </PageWrapper>
    </>
  )
}
